module.exports = function isArray(x) {
  return x instanceof Array;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/isArray.js
 ** module id = 75
 ** module chunks = 0
 **/